export const BASE_URL_API = () => {
    const hostname = window.location.hostname;
    const apiHostname = hostname.replace(/^app\./, "api.");

    if (hostname.includes("localhost")) {
        return "http://api.localhost.scraperforce.com:8089";
    }

    return `https://${apiHostname}`;
}
export const LOGIN_URL = () => {
    const hostname = window.location.hostname;
    const apiHostname = hostname.replace(/^app\./, "login.");

    if (hostname.includes("localhost")) {
        return "http://login.localhost.scraperforce.com:8080/sign-in";
    }

    return `https://${apiHostname}/sign-in`;
}

//date format using with moment-js
export const DATE_TIME = "DD MMM YYYY";
export const DATE_TIME_FORMAT = "DD MMM YYYY H:mm:ss";
